import React, { useState } from "react";
import {
  Typography,
  FormControl,
  TextField,
  FormControlLabel,
  Checkbox,
  InputLabel,
  Select,
  MenuItem,
  FormGroup,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormHelperText,
  Tabs,
  Tab,
  TextareaAutosize,
} from "@material-ui/core";
import ActionButton from "../../components/ActionButton";
import { makeStyles } from "@material-ui/core/styles";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import axios from "../../AxiosClient";
import PropertyNames from "../../PropertyNames";
import { useSelector, useDispatch } from "react-redux";
import { setApplicationProperties } from "../../redux/actions/universalActions.js";

const useStyles = makeStyles((theme) => ({
  header: {
    marginBottom: 15,
    display: "flex",
  },
  container: {
    height: "100%",
    width: "100%",
  },
  flexContainer: {
    display: "flex",
  },
}));
const uiLocation = `${window.location.protocol}//${window.location.hostname}${
  window.location.port ? ":" + window.location.port : ""
}`;
function EmailSettings() {
  const [saving, setSaving] = useState(false);
  const [savingTemplates, setSavingTemplates] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [templateTab, setTemplateTab] = useState(0);
  const [workflowSelection, setWorkflowSelection] = useState("review");
  const [workflowTemplate, setWorkflowTemplate] = useState(PropertyNames.WORKFLOW_EMAIL_TEMPLATE_REVIEW);
  const [workflowSubject, setWorkflowSubject] = useState(PropertyNames.WORKFLOW_EMAIL_SUBJECT_REVIEW);

  const classes = useStyles();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const [updatedProperties, setUpdatedProperties] = useState([]);
  const dispatch = useDispatch();
  const properties = useSelector((state) => ({
    ...state.setting.applicationProperties,
  }));

  const handleCheckboxChange = (propertyKey) => (e) => {
    updateProperties(propertyKey, e.target.checked ? "true" : "false");
  };

  const updateProperties = (propertyKey, propertyValue) => {
    if (updatedProperties.indexOf(propertyKey) === -1) {
      setUpdatedProperties([...updatedProperties, propertyKey]);
    }
    dispatch(
      setApplicationProperties({
        ...properties,
        [propertyKey]: propertyValue,
      })
    );
  };

  const saveTemplates = () => {
    setSavingTemplates(true);
    axios
      .patch("/application-property/", {

        [PropertyNames.WORKFLOW_EMAIL_SUBJECT_REVIEW]:
          properties[PropertyNames.WORKFLOW_EMAIL_SUBJECT_REVIEW],
        [PropertyNames.WORKFLOW_EMAIL_TEMPLATE_REVIEW]:
          properties[PropertyNames.WORKFLOW_EMAIL_TEMPLATE_REVIEW],
        [PropertyNames.WORKFLOW_EMAIL_SUBJECT_APPROVE]:
          properties[PropertyNames.WORKFLOW_EMAIL_SUBJECT_APPROVE],
        [PropertyNames.WORKFLOW_EMAIL_TEMPLATE_APPROVE]:
          properties[PropertyNames.WORKFLOW_EMAIL_TEMPLATE_APPROVE],
        [PropertyNames.WORKFLOW_EMAIL_SUBJECT_PUBLISH]:
          properties[PropertyNames.WORKFLOW_EMAIL_SUBJECT_PUBLISH],
        [PropertyNames.WORKFLOW_EMAIL_TEMPLATE_PUBLISH]:
          properties[PropertyNames.WORKFLOW_EMAIL_TEMPLATE_PUBLISH],
        [PropertyNames.WORKFLOW_EMAIL_SUBJECT]:
          properties[PropertyNames.WORKFLOW_EMAIL_SUBJECT],
        [PropertyNames.DISCUSSIONS_EMAIL_SUBJECT]:
          properties[PropertyNames.DISCUSSIONS_EMAIL_SUBJECT],
        [PropertyNames.SYSTEM_EMAIL_SUBJECT]:
          properties[PropertyNames.SYSTEM_EMAIL_SUBJECT],
        [PropertyNames.REQUIRED_READING_EMAIL_SUBJECT]:
          properties[PropertyNames.REQUIRED_READING_EMAIL_SUBJECT],
        [PropertyNames.REWORK_EMAIL_SUBJECT]:
          properties[PropertyNames.REWORK_EMAIL_SUBJECT],
        [PropertyNames.WORKFLOW_EMAIL_TEMPLATE]:
          properties[PropertyNames.WORKFLOW_EMAIL_TEMPLATE],
        [PropertyNames.DISCUSSIONS_EMAIL_TEMPLATE]:
          properties[PropertyNames.DISCUSSIONS_EMAIL_TEMPLATE],
        [PropertyNames.SYSTEM_EMAIL_TEMPLATE]:
          properties[PropertyNames.SYSTEM_EMAIL_TEMPLATE],
        [PropertyNames.REQUIRED_READING_EMAIL_TEMPLATE]:
          properties[PropertyNames.REQUIRED_READING_EMAIL_TEMPLATE],
        [PropertyNames.REWORK_EMAIL_TEMPLATE]:
          properties[PropertyNames.REWORK_EMAIL_TEMPLATE],
      })
      .then(() => {
        enqueueSnackbar(t("properties_updated_snackbar"), {
          variant: "success",
        });
        setSavingTemplates(false);
        setDialogOpen(false);
      })
      .catch((err) => {
        enqueueSnackbar(t("properties_updated_error_snackbar"), {
          variant: "error",
        });
        setSavingTemplates(false);
      });
  };

  const changeWorkflowType = (e, value) => {
    setWorkflowSelection(value);
    value == "review" ? setWorkflowTemplate(PropertyNames.WORKFLOW_EMAIL_TEMPLATE_REVIEW) : value == "approve" ? setWorkflowTemplate(PropertyNames.WORKFLOW_EMAIL_TEMPLATE_APPROVE) : setWorkflowTemplate(PropertyNames.WORKFLOW_EMAIL_TEMPLATE_PUBLISH);
    value == "review" ? setWorkflowSubject(PropertyNames.WORKFLOW_EMAIL_SUBJECT_REVIEW) : value == "approve" ? setWorkflowSubject(PropertyNames.WORKFLOW_EMAIL_SUBJECT_APPROVE) : setWorkflowSubject(PropertyNames.WORKFLOW_EMAIL_SUBJECT_PUBLISH);
  }


  const save = () => {
    setSaving(true);
    let updated = {};
    // so we only patch the changed props and not everything...
    for (const key of updatedProperties) {
      updated[key] = properties[key];
    }
    axios
      .patch("/application-property/", {
        ...updated,
        [PropertyNames.UI_URL]: uiLocation,
      })
      .then(() => {
        enqueueSnackbar(t("properties_updated_snackbar"), {
          variant: "success",
        });
        setSaving(false);
      })
      .catch((err) => {
        enqueueSnackbar(t("properties_updated_error_snackbar"), {
          variant: "error",
        });
        setSaving(false);
      });
  };

  const handleChange = (propertyKey) => (e) => {
    updateProperties(propertyKey, e.target.value);
  };

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <Typography variant="h5" style={{ marginRight: 10 }}>
          {t("email_settings_header")}
        </Typography>
        <ActionButton
          variant="contained"
          color="primary"
          onClick={save}
          loading={saving}
        >
          {t("global_save")}
        </ActionButton>
      </div>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <Typography variant="h6" gutterBottom>
          {t("email_notifications_header")}
        </Typography>
        <Typography variant="body2" gutterBottom>
          {t("email_notifications_subheader")}
        </Typography>
        <FormControl>
          <FormGroup>
            <FormControlLabel
              label={t("email_notifications_system")}
              control={
                <Checkbox
                  value=""
                  checked={
                    properties[PropertyNames.SYSTEM_EMAILS_ENABLED] === "true"
                  }
                  onChange={handleCheckboxChange(
                    PropertyNames.SYSTEM_EMAILS_ENABLED
                  )}
                  color="primary"
                />
              }
            />
            <FormControlLabel
              label={t("email_notifications_required_reading")}
              control={
                <Checkbox
                  value=""
                  checked={
                    properties[
                      PropertyNames.REQUIRED_READING_EMAILS_ENABLED
                    ] === "true"
                  }
                  onChange={handleCheckboxChange(
                    PropertyNames.REQUIRED_READING_EMAILS_ENABLED
                  )}
                  color="primary"
                />
              }
            />
            <FormControlLabel
              label={t("email_notifications_discussions")}
              control={
                <Checkbox
                  value=""
                  checked={
                    properties[PropertyNames.DISCUSSIONS_EMAILS_ENABLED] ===
                    "true"
                  }
                  onChange={handleCheckboxChange(
                    PropertyNames.DISCUSSIONS_EMAILS_ENABLED
                  )}
                  color="primary"
                />
              }
            />
            <FormControlLabel
              label={t("email_notifications_workflow")}
              control={
                <Checkbox
                  value=""
                  checked={
                    properties[PropertyNames.WORKFLOW_EMAILS_ENABLED] === "true"
                  }
                  onChange={handleCheckboxChange(
                    PropertyNames.WORKFLOW_EMAILS_ENABLED
                  )}
                  color="primary"
                />
              }
            />
            <FormControlLabel
              label={t("email_notifications_rework")}
              control={
                <Checkbox
                  value=""
                  checked={
                    properties[PropertyNames.REWORK_EMAILS_ENABLED] === "true"
                  }
                  onChange={handleCheckboxChange(
                    PropertyNames.REWORK_EMAILS_ENABLED
                  )}
                  color="primary"
                />
              }
            />
          </FormGroup>
        </FormControl>
        <Typography variant="h6" gutterBottom>
          {t("email_templates_header")}
        </Typography>
        <Typography variant="body2" gutterBottom>
          {t("email_templates_subheader")}
        </Typography>
        <div className={classes.flexContainer} style={{ marginBottom: 10 }}>
          <Button onClick={() => setDialogOpen(true)} variant="contained">
            {t("email_edit_templates")}
          </Button>
          <Dialog
            fullWidth
            maxWidth="md"
            open={dialogOpen}
            onClose={() => setDialogOpen(false)}
            aria-labelledby="template-dialog-title"
            aria-describedby="template-dialog-description"
          >
            <DialogTitle id="template-dialog-title">
              {t("template_dialog_header")}
            </DialogTitle>
            <DialogContent>
              <Tabs
                centered
                value={templateTab}
                onChange={(_e, nv) => setTemplateTab(nv)}
              >
                <Tab label={t("global_required_reading")} />
                <Tab label={t("global_discussion_plural")} />
                <Tab label={t("global_workflow")} />
                <Tab label={t("system_template_tab")} />
                <Tab label={t("global_rework")} />
              </Tabs>
              {templateTab === 0 && (
                <div style={{ marginTop: 10 }}>
                  <Typography>
                    {t("required_reading_template_header")}
                  </Typography>
                  <ul>
                    <li>
                      {"{{title}}"} - {t("req_reading_template_title_value")}
                    </li>
                    <li>
                      {"{{description}}"} -{" "}
                      {t("req_reading_template_description_value")}
                    </li>
                    <li>
                      {"{{creatorName}}"} -{" "}
                      {t("req_reading_creator_description_value")}
                    </li>
                    <li>
                      {"{{documents}}"} -{" "}
                      {t("req_reading_documents_description_value")} ({"<li>"})
                    </li>
                    <li>
                      {"{{expiryDate}}"} -{" "}
                      {t("req_reading_expiry_description_value")}
                    </li>
                  </ul>
                  <TextField
                    style={{ width: "100%" }}
                    label={t("email_subject")}
                    value={
                      properties[PropertyNames.REQUIRED_READING_EMAIL_SUBJECT]
                    }
                    onChange={handleChange(
                      PropertyNames.REQUIRED_READING_EMAIL_SUBJECT
                    )}
                    margin="normal"
                  />
                  <Typography gutterBottom>{t("email_body")}</Typography>
                  <TextareaAutosize
                    minRows={10}
                    value={
                      properties[PropertyNames.REQUIRED_READING_EMAIL_TEMPLATE]
                    }
                    onChange={handleChange(
                      PropertyNames.REQUIRED_READING_EMAIL_TEMPLATE
                    )}
                    style={{ width: "100%" }}
                  />
                </div>
              )}
              {templateTab === 1 && (
                <>
                  <div style={{ marginTop: 10 }}>
                    <Typography>{t("discussions_template_header")}</Typography>
                    <ul>
                      <li>
                        {"{{discussionTitle}}"} -{" "}
                        {t("discussion_template_title_value")}
                      </li>
                      <li>
                        {"{{entryLink}}"} -{" "}
                        {t("discussion_template_entry_link_value")}
                      </li>
                    </ul>
                    <TextField
                      style={{ width: "100%" }}
                      label={t("email_subject")}
                      value={
                        properties[PropertyNames.DISCUSSIONS_EMAIL_SUBJECT]
                      }
                      onChange={handleChange(
                        PropertyNames.DISCUSSIONS_EMAIL_SUBJECT
                      )}
                      margin="normal"
                    />
                    <Typography gutterBottom>{t("email_body")}</Typography>
                    <TextareaAutosize
                      minRows={10}
                      value={
                        properties[PropertyNames.DISCUSSIONS_EMAIL_TEMPLATE]
                      }
                      onChange={handleChange(
                        PropertyNames.DISCUSSIONS_EMAIL_TEMPLATE
                      )}
                      style={{ width: "100%" }}
                    />
                  </div>
                </>
              )}
              {templateTab === 2 && (
                <>
                 <Tabs
                  centered
                  value={workflowSelection}
                  onChange={changeWorkflowType}
                  >
                    <Tab label={"Review"} value={"review"}/>
                    <Tab label={"Approve"} value={"approve"}/>
                    <Tab label={"Publish"} value={"publish"}/>
                  </Tabs>
                  <div style={{ marginTop: 10 }}>
                    <Typography>{t("workflow_template_header")}</Typography>
                    <ul>
                      <li>
                        {"{{workflowAction}}"} -{" "}
                        {t("workflow_template_action_value")}
                      </li>
                      <li>
                        {"{{documentLink}}"} -{" "}
                        {t("workflow_template_document_link_value")}
                      </li>
                      <li>
                        {"{{documentTitle}}"} -{" "}
                        {t("workflow_template_document_title_value")}
                      </li>
                      <li>
                        {"{{revisionTitle}}"} -{" "}
                        {t("workflow_template_revision_title_value")}
                      </li>
                      <li>
                        {"{{contentDescription}}"} -{" "}
                        {t("workflow_template_content_description_value")}
                      </li>
                      <li>
                        {"{{topic}}"} -{" "}
                        {t("workflow_template_topic_value")}
                      </li>
                      <li>
                        {"{{authorName}}"} -{" "}
                        {t("workflow_template_author_name_value")}
                      </li>
                      <li>
                        {"{{createdDate}}"} -{" "}
                        {t("workflow_template_created_date_value")}
                      </li>
                      {workflowSelection != "review" &&
                        <>
                          <li>
                            {"{{reviewerName}}"} -{" "}
                            {t("workflow_template_reviewer_name_value")}
                          </li>
                          <li>
                            {"{{reviewerNameAndDate}}"} -{" "}
                            {t("workflow_reviewer_name_and_date_value")}
                          </li>
                          <li>
                            {"{{dateAndReviewerName}}"} -{" "}
                            {t("workflow_template_date_and_reviewer_name_value")}
                          </li>
                        </>
                      }
                      {workflowSelection == "publish" &&
                        <>
                          <li>
                            {"{{approverName}}"} -{" "}
                            {t("workflow_template_approver_name_value")}
                          </li>
                          <li>
                            {"{{approverNameAndDate}}"} -{" "}
                            {t("workflow_template_approver_name_and_date_value")}
                          </li>
                          <li>
                            {"{{dateAndApproverName}}"} -{" "}
                            {t("workflow_template_date_and_approver_name_value")}
                          </li>
                        </>
                      }
                    </ul>                    
                    <TextField
                      style={{ width: "100%" }}
                      label={t("email_subject")}
                      value={properties[workflowSubject]}
                      onChange={handleChange(workflowSubject)}
                      margin="normal"
                    />
                    <Typography gutterBottom>{t("email_body")}</Typography>
                    <TextareaAutosize
                      minRows={10}
                      value={properties[workflowTemplate]}
                      onChange={handleChange(workflowTemplate)}
                      style={{ width: "100%" }}
                    />
                  </div>
                </>
              )}
              {templateTab === 3 && (
                <>
                  <div style={{ marginTop: 10 }}>
                    <Typography>{t("system_template_header")}</Typography>
                    <ul>
                      <li>
                        {"{{alert}}"} - {t("system_template_alert_value")}
                      </li>
                    </ul>
                    <TextField
                      style={{ width: "100%" }}
                      label={t("email_subject")}
                      value={properties[PropertyNames.SYSTEM_EMAIL_SUBJECT]}
                      onChange={handleChange(
                        PropertyNames.SYSTEM_EMAIL_SUBJECT
                      )}
                      margin="normal"
                    />
                    <Typography gutterBottom>{t("email_body")}</Typography>
                    <TextareaAutosize
                      minRows={10}
                      value={properties[PropertyNames.SYSTEM_EMAIL_TEMPLATE]}
                      onChange={handleChange(
                        PropertyNames.SYSTEM_EMAIL_TEMPLATE
                      )}
                      style={{ width: "100%" }}
                    />
                  </div>
                </>
              )}
              {templateTab === 4 && (
                <>
                  <div style={{ marginTop: 10 }}>
                    <Typography>{t("rework_template_header")}</Typography>
                    <ul>
                      <li>
                        {"{{reworkAction}}"} -{" "}
                        {t("rework_template_action_value")}
                      </li>
                      <li>
                        {"{{user}}"} - {t("rework_template_user_value")}
                      </li>
                      <li>
                        {"{{reworkAction}}"} -{" "}
                        {t("rework_template_rework_action_value")}
                      </li>
                      <li>
                        {"{{user}}"} -{" "}
                        {t("rework_template_user_value")}
                      </li>
                      <li>
                        {"{{documentLink}}"} -{" "}
                        {t("rework_template_document_link_value")}
                      </li>
                      <li>
                        {"{{documentTitle}}"} -{" "}
                        {t("rework_template_document_title_value")}
                      </li>
                      <li>
                        {"{{contentDescription}}"} -{" "}
                        {t("rework_template_content_description_value")}
                      </li>
                      <li>
                        {"{{topic}}"} -{" "}
                        {t("rework_template_topic_value")}
                      </li>
                    </ul>
                    <TextField
                      style={{ width: "100%" }}
                      label={t("email_subject")}
                      value={properties[PropertyNames.REWORK_EMAIL_SUBJECT]}
                      onChange={handleChange(
                        PropertyNames.REWORK_EMAIL_SUBJECT
                      )}
                      margin="normal"
                    />
                    <Typography gutterBottom>{t("email_body")}</Typography>
                    <TextareaAutosize
                      minRows={10}
                      value={properties[PropertyNames.REWORK_EMAIL_TEMPLATE]}
                      onChange={handleChange(
                        PropertyNames.REWORK_EMAIL_TEMPLATE
                      )}
                      style={{ width: "100%" }}
                    />
                  </div>
                </>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setDialogOpen(false)} color="primary">
                {t("global_cancel")}
              </Button>
              <ActionButton
                loading={savingTemplates}
                onClick={saveTemplates}
                color="primary"
                autoFocus
              >
                {t("global_save")}
              </ActionButton>
            </DialogActions>
          </Dialog>
        </div>
        <Typography variant="h6" gutterBottom>
          {t("email_server_details_header")}
        </Typography>
        <Typography variant="body2" gutterBottom>
          {t("email_server_details_subheader")}
        </Typography>
        <div className={classes.flexContainer}>
          <TextField
            required
            label={t("smtp_server_hostname")}
            value={properties[PropertyNames.SMTP_SERVER]}
            onChange={handleChange(PropertyNames.SMTP_SERVER)}
            style={{ marginRight: 20, minWidth: "25%" }}
            margin="normal"
          />
          <TextField
            required
            style={{ marginRight: 20, minWidth: "25%" }}
            label={t("smtp_server_port")}
            value={properties[PropertyNames.SMTP_PORT]}
            onChange={handleChange(PropertyNames.SMTP_PORT)}
            margin="normal"
          />

          <FormControl style={{ marginTop: 15, minWidth: "10%" }}>
            <InputLabel id="smtp-encryption-type-label">
              {t("smtp_encryption_type")}
            </InputLabel>
            <Select
              labelId="smtp-encryption-type-label"
              id="smtp-encryption-type"
              value={properties[PropertyNames.SMTP_ENCRYPTION]}
              onChange={handleChange(PropertyNames.SMTP_ENCRYPTION)}
            >
              <MenuItem value="none">None</MenuItem>
              <MenuItem value="starttls">STARTTLS</MenuItem>
              <MenuItem value="ssltls">SSL/TLS</MenuItem>
            </Select>
          </FormControl>
        </div>
        <TextField
          required
          label={t("smtp_from")}
          style={{ maxWidth: "25%" }}
          value={properties[PropertyNames.SMTP_FROM]}
          onChange={handleChange(PropertyNames.SMTP_FROM)}
          margin="normal"
        />
        <div className={classes.flexContainer}>
          <TextField
            required
            style={{ marginRight: 20, minWidth: "25%" }}
            label={t("smtp_username")}
            value={properties[PropertyNames.SMTP_USER]}
            onChange={handleChange(PropertyNames.SMTP_USER)}
            margin="normal"
          />
          <TextField
            required
            label={t("smtp_password")}
            value={properties[PropertyNames.SMTP_PASSWORD]}
            onChange={handleChange(PropertyNames.SMTP_PASSWORD)}
            style={{ marginRight: 20, minWidth: "25%" }}
            helperText={t("smtp_password_helper_text")}
            type="password"
            margin="normal"
          />
        </div>
      </div>
    </div>
  );
}

export default EmailSettings;
